/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class UserService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allUser(useroffset, pagelimit, subscription, countrygroupId, userstatus, applicationId,countrycode): Promise<any> {
        var data = {
            offset: useroffset,
            pagelimit: pagelimit,
            subscription : subscription,
            countrygroupId: countrygroupId,
            loginType: userstatus,
            applicationId: applicationId,
            countrycode : countrycode
        }
        return this.httpmanagerService.HttpPost('susers', JSON.stringify(data), "").then(data => {
            return data.data
        })
    }
    directSearch(searchcontent): Promise<any> {
        var data = {
            searchcontent: searchcontent
        }
        return this.httpmanagerService.HttpPost('susers/directSearch', JSON.stringify(data), "").then(data => {
            return data.data
        })
    }
    correctSubscriptions(): Promise<any> {
        var data = {
            
        }
        return this.httpmanagerService.HttpPost('susers/correctsubscriptions', JSON.stringify(data), "").then(data => {
            return data
        })
    }
    paginationList(subscription,countrygroupId, userstatus, applicationId,countrycode): Promise<any> {
        var data = {
            subscription : subscription,
            countrygroupId: countrygroupId,
            loginType: userstatus,
            applicationId: applicationId,
            countrycode : countrycode
        }
        return this.httpmanagerService.HttpPost('susers/paginationlist', JSON.stringify(data), "").then(data => {
            return data
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/user/user.service.ts